import { formatSize } from 'pano-utils';
import { type Files, LibType } from '@types';
import { LIB_FRAME_LIMIT, LIB_SIZE_LIMIT } from '../constants';

const maxSize = LIB_SIZE_LIMIT[LibType.sequenceFrame];

interface SeqFrameItem {
  order: number;
  file: File;
}

const re = /(.*)(_)([1-9]\d*)\.(\w*)$/;

const warningError = (message: string) => {
  const e = new Error(message);
  e.name = 'Warning';
  return e;
};

export default function seqFrameCheck(files: Files) {
  const count = files.length;
  let totalSize = 0;
  let seqName: string | null = null;
  let seqSuffix: string | null = null;
  if (count > LIB_FRAME_LIMIT) {
    return Promise.reject(new Error(`最多支持上传${LIB_FRAME_LIMIT}张`));
  }
  const list: SeqFrameItem[] = [];
  for (let i = 0; i < count; i++) {
    const file = files[i];
    if (file.size > maxSize) {
      return Promise.reject(
        warningError(`单个图片体积不超过${formatSize(maxSize)}`)
      );
    }
    const match = file.name.match(re);
    if (!match) {
      return Promise.reject(
        warningError(
          `文件名错误 (${file.name})，请使用后缀为“_XX”的命名，如: "图片名称_6.png"。`
        )
      );
    }
    const name = match[1];
    const number = match[3];
    const suffix = match[4];
    if (seqName === null) {
      seqName = name;
    } else if (name !== seqName) {
      return Promise.reject(
        warningError(`文件名错误 (${file.name})，请使用相同的前缀名称。`)
      );
    }
    if (seqSuffix === null) {
      seqSuffix = suffix;
    } else if (suffix !== seqSuffix) {
      return Promise.reject(
        warningError(`文件名错误 (${file.name})，请使用相同类型的图片文件。`)
      );
    }
    list.push({
      order: Number.parseInt(number),
      file,
    });
    totalSize += file.size;
  }
  if (!seqName) {
    return Promise.reject(warningError('文件名错误，请使用相同的前缀名称。'));
  }
  if (!seqSuffix) {
    return Promise.reject(
      warningError('文件扩展名错误，请使用相同类型的图片文件。')
    );
  }
  list.sort((a, b) => a.order - b.order);
  for (let i = 0; i < list.length; i++) {
    if (i !== list[i].order - 1) {
      return Promise.reject(
        warningError(`请使用从"1"开始的连续数字命名文件. 缺失编号: ${i + 1}`)
      );
    }
  }
  return Promise.resolve({ list, seqSuffix, seqName, totalSize });
}
